<template>
  <b-overlay
    :show="loading"
    rounded="sm"
    spinner-type="grow"
    spinner-variant="warning"
  >
    <div v-if="this.surgicalCase">
      <b-jumbotron>
        <b-row align-h="between" align-v="start">
          <b-col cols="4">
            <b-row>
              <font-awesome-layers full-width class="fa-3x logo">
                <font-awesome-icon icon="square" style="color: #85458a" />
                <font-awesome-icon
                  icon="briefcase-medical"
                  transform="shrink-7"
                  style="color: white"
                />
              </font-awesome-layers>
              <div style="float: right">
                Surgical Case
                <h5>
                  <strong>{{
                    this.surgicalCase.metadata.surgicalCaseId
                  }}</strong>
                </h5>
              </div>
            </b-row>
          </b-col>
          <b-col offset="4" cols="4" style="text-align: right">
            <b-button-group size="sm">
              <b-button
                id="idEditSurgicalCaseBtn"
                :disabled="
                  surgicalCase.metadata.commentedCaseState.surgicalCaseState ===
                  'Cancelled'
                "
                variant="outline-primary"
                @click="editClicked"
                >Edit</b-button
              >
              <b-button
                id="idCancelSurgicalCaseBtn"
                :disabled="
                  surgicalCase.metadata.commentedCaseState.surgicalCaseState ===
                  'Cancelled'
                "
                v-b-modal="'idCancelSurgicalCasedModal'"
                variant="outline-primary"
                >Cancel Surgical Case</b-button
              >
            </b-button-group>
          </b-col>
        </b-row>
      </b-jumbotron>
      <SurgicalCaseCancelModal
        :surgicalCaseId="surgicalCase.metadata.surgicalCaseId"
        @caseCancelled="handleCaseCancelled"
      />
      <div id="caseDetails" v-if="!this.showSpinner">
        <b-form-row>
          <b-col sm="2">
            <strong>Case Number</strong>
          </b-col>
          <b-col sm="4">
            <div id="idCaseNumber">
              {{ this.surgicalCase.metadata.surgicalCaseId }}
            </div>
          </b-col>
          <b-col sm="2">
            <strong>Hospital No- Name</strong>
          </b-col>
          <b-col sm="4">
            <div id="idHospitalName">{{ hospitalName }}</div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="2">
            <strong>Surgery Start Date Time</strong>
          </b-col>
          <b-col sm="4">
            <div id="idSurgeryStartDate">{{ surgeryDate }}</div>
          </b-col>
          <b-col sm="2">
            <strong>Surgeon No- Name</strong>
          </b-col>
          <b-col sm="4">
            <div id="idSurgeonName">{{ surgeonName }}</div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="2">
            <strong>Patient ID</strong>
          </b-col>
          <b-col sm="4">
            <div id="idPatientID">{{ this.surgicalCase.patientId }}</div>
          </b-col>
          <b-col sm="2">
            <strong>Procedure</strong>
          </b-col>
          <b-col sm="4">
            <div id="idProcedure">{{ this.surgicalCase.procedure }}</div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="2">
            <strong>Status</strong>
          </b-col>
          <b-col sm="4">
            <div id="idStatus">
              {{
                this.surgicalCase.metadata.commentedCaseState.surgicalCaseState
              }}
            </div>
          </b-col>
          <b-col sm="2">
            <strong>Covering Reps</strong>
          </b-col>
          <b-col sm="2">
            <ul id="idCoveringReps">
              <li
                v-for="rep in this.surgicalCase.coveringReps"
                :key="rep.email"
              >
                {{ rep.firstName }} {{ rep.lastName }}
              </li>
            </ul>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="2">
            <strong>Cap Price</strong>
          </b-col>
          <b-col sm="4">
            <b-form-checkbox
              id="idCapPrice"
              style="float: left"
              checked="false"
              disabled
            />
          </b-col>
          <b-col sm="2">
            <strong>PO Uploaded</strong>
          </b-col>
          <b-col sm="4">
            <b-form-checkbox
              id="idPoUploaded"
              style="float: left"
              checked="false"
              disabled
            />
          </b-col>
        </b-form-row>
      </div>
      <div id="idCaseNav">
        <b-tabs
          @activate-tab="checkTabClick"
          v-model="tabIndex"
          nav-class="details-nav"
          active-nav-item-class="navActive"
        >
          <b-tab id="idCaseNavDetails" lazy title="Details">
            <SurgicalCaseDetails :surgicalCase="this.surgicalCase" />
          </b-tab>
          <b-tab id="idCaseNavRelatedList" lazy title="Related List">
            <SurgicalCaseRelatedList
              :surgicalCase="this.surgicalCase"
              @tprClicked="relatedListTprClicked"
            />
          </b-tab>
          <b-tab
            id="idCaseNavAddTreatmentPlanRequest"
            lazy
            title="Add Treatment Plan Request"
          >
            <TreatmentPlanRequest
              :surgicalCase="surgicalCase"
              :selectedTpr="selectedTpr"
              :key="selectedTprId"
              @cloned="handleClone"
              @surgeryDateUpdated="handleSurgeryDateUpdate"
            />
          </b-tab>
        </b-tabs>
      </div>
      <b-spinner
        variant="warning"
        class="m-5"
        style="width: 3rem; height: 3rem"
        v-if="this.showSpinner"
      ></b-spinner>
    </div>
  </b-overlay>
</template>

<script>
import {} from "rhs-treatment-plan-request-handling-api-v2";
import moment from "moment";
import _ from "lodash";

import SurgicalCaseDetails from "@/components/SurgicalCaseDetails.vue";
import SurgicalCaseRelatedList from "@/components/SurgicalCaseRelatedList.vue";
import SurgicalCaseCancelModal from "@/components/SurgicalCaseCancelModal.vue";
import TreatmentPlanRequest from "@/components/TreatmentPlanRequest.vue";
export default {
  data() {
    return {
      loading: false,
      tabIndex: 0,
      showSpinner: true,
      surgicalCase: null,
      selectedTpr: null,
    };
  },
  components: {
    SurgicalCaseRelatedList,
    SurgicalCaseDetails,
    TreatmentPlanRequest,
    SurgicalCaseCancelModal,
  },
  async created() {
    this.showSpinner = true;
    this.surgicalCaseId = this.$route.query.id;
    const response = await this.$surgicalCaseApi.surgicalcasesIdGet(
      this.surgicalCaseId
    );
    this.surgicalCase = response;
    this.showSpinner = false;
  },
  mounted() {},
  computed: {
    selectedTprId() {
      return this.selectedTpr?.metadata?.requestId;
    },
    surgeryDate() {
      return moment(this.surgicalCase.surgeryStartDateTime).format(
        "M/D/YYYY, h:mm A"
      );
    },
    hospitalName() {
      if (_.some(this.surgicalCase.hospitalName, _.isNotEmpty))
        return (
          this.surgicalCase.hospitalNumber +
          " - " +
          this.surgicalCase.hospitalName
        );
      else return "";
    },
    surgeonName() {
      if (_.some(this.surgicalCase.surgeon, _.isNotEmpty))
        return (
          this.surgicalCase.surgeon.email +
          " - " +
          this.surgicalCase.surgeon.firstName +
          " " +
          this.surgicalCase.surgeon.lastName
        );
      else return "";
    },
    coveringReps() {
      var reps = "";
      this.surgicalCase.coveringReps.forEach((rep) => {
        reps += rep.firstName;
        reps += " ";
        reps += rep.lastName;
        reps += "\n";
      });
      return reps;
    },
  },
  methods: {
    handleSurgeryDateUpdate(newDate) {
      this.surgicalCase.surgeryStartDateTime = newDate;
    },
    async handleClone(newRequestId) {
      const response =
        await this.$treatmentPlanRequestsApi.treatmentplanrequestsIdGet(
          newRequestId
        );
      this.selectedTpr = response;
    },
    async handleCaseCancelled(reason) {
      // Cancel all attached TPRs
      try {
        this.surgicalCase.treatmentPlanRequests.forEach((tpr) => {
          this.$treatmentPlanRequestsStateApi.treatmentplanrequestsIdStatePut(
            tpr.entityId,
            "Cancelled"
          );
        });
      } catch (e) {
        this.$root.$emit("showAlert", {
          type: "error",
          msg:
            "Error " +
            e.status +
            " while canceling attached Treatment Plan Requests",
        });
      }

      try {
        // Cancel Surgical case
        const caseStateResponse =
          await this.$surgicalCaseApi.surgicalcasesIdStatePut(
            this.surgicalCaseId,
            {
              surgicalCaseState: "Cancelled",
              comment: reason,
            }
          );
        // Update UI and go back to details
        this.surgicalCase.metadata.commentedCaseState =
          caseStateResponse.commentedCaseState;
        this.tabIndex = 0;
        this.$forceUpdate();
      } catch (e) {
        this.$root.$emit("showAlert", {
          type: "error",
          msg: "Error " + e.status + " while canceling Surgical Case",
        });
      }
    },
    relatedListTprClicked(tprId) {
      var opts = {
        externalReference: tprId,
        includeAcknowledgedRequests: true,
      };
      this.$treatmentPlanRequestsApi
        .treatmentplanrequestsGet(opts)
        .then((response) => {
          this.tabIndex = 2;
          this.selectedTpr = response.content[0];
        });
    },
    async checkTabClick(newTabIndex, prevTabIndex, bvEvt) {
      this.$emit("refreshToken");
      if (newTabIndex !== 2) {
        this.selectedTpr = null;
        // If Add Treatment Plan Request was clicked..
      } else {
        // .. and more than one TPR is attached: Forward to "Related List"
        // to choose a TPR
        if (
          this.surgicalCase.treatmentPlanRequests.length > 1 &&
          !this.selectedTpr
        ) {
          bvEvt.preventDefault();
          this.tabIndex = 1;
          // .. and only one TPR is attached, choose this one
        } else if (
          this.surgicalCase.treatmentPlanRequests.length === 1 &&
          !this.selectedTpr
        ) {
          bvEvt.preventDefault();
          this.loading = true;
          var opts = {
            externalReference:
              this.surgicalCase.treatmentPlanRequests[0].entityDescriptor,
            includeAcknowledgedRequests: true,
          };
          try {
            this.$treatmentPlanRequestsApi
              .treatmentplanrequestsGet(opts)
              .then((response) => {
                this.tabIndex = 2;
                this.selectedTpr = response.content[0];
                this.loading = false;
              });
          } catch (e) {
            this.$root.$emit("showAlert", {
              type: "error",
              msg:
                "Error " +
                e.status +
                " while retrieving the attached Treatment Plan Request",
            });
          }
          // .. and no TPR is attached, create new TPR
        } else if (
          !this.surgicalCase.treatmentPlanRequests.length &&
          !this.selectedTpr
        ) {
          if (
            this.surgicalCase.metadata.commentedCaseState.surgicalCaseState ===
            "Cancelled"
          ) {
            bvEvt.preventDefault();
            this.$root.$emit("showAlert", {
              type: "error",
              msg: "Cannot create new Treatment Plan Request on a cancelled Case.",
            });
          } else {
            this.loading = true;
            bvEvt.preventDefault();
            let newTprDto = {};
            // Build TPR DTO with surgical case information
            const newDescriptor =
              this.surgicalCase.metadata.surgicalCaseId + "-1";
            newTprDto.externalReference = newDescriptor;
            newTprDto.region = this.surgicalCase.branchName;
            newTprDto.treatment = {};
            newTprDto.treatment.hospitalName = this.surgicalCase.hospitalName;
            newTprDto.treatment.hospitalReference =
              this.surgicalCase.hospitalNumber;
            newTprDto.treatment.operativeSide = this.surgicalCase.operativeSide
              ? this.surgicalCase.operativeSide
              : null;
            newTprDto.treatment.surgeryDate =
              this.surgicalCase.surgeryStartDateTime;
            newTprDto.treatment.surgeonName = this.surgicalCase.surgeon;
            if (this.surgicalCase.coveringReps.length === 1) {
              newTprDto.primaryContact = this.surgicalCase.coveringReps[0];
            }
            try {
              // Create new TPR
              const tprPostResponse =
                await this.$treatmentPlanRequestsApi.treatmentplanrequestsPost(
                  "Robotics",
                  newTprDto
                );
              // Attach TPR to Surgical Case
              this.surgicalCase.treatmentPlanRequests.push({
                entityId: tprPostResponse.requestId,
                entityDescriptor: newDescriptor,
              });
              await this.$surgicalCaseApi.surgicalcasesIdPut(
                this.surgicalCase.metadata.surgicalCaseId,
                _.omit(this.surgicalCase, "metadata")
              );
              // Set Surgical Case State to "Requested"
              const caseStateResponse =
                await this.$surgicalCaseApi.surgicalcasesIdStatePut(
                  this.surgicalCase.metadata.surgicalCaseId,
                  { surgicalCaseState: "Requested" }
                );
              this.surgicalCase.metadata.commentedCaseState =
                caseStateResponse.commentedCaseState;
              // Get TPR Entity DTO
              this.selectedTpr =
                await this.$treatmentPlanRequestsApi.treatmentplanrequestsIdGet(
                  tprPostResponse.requestId
                );
              // Select TPR
              this.tabIndex = 2;
            } catch (e) {
              this.$root.$emit("showAlert", {
                type: "error",
                msg:
                  "Error " +
                  e.status +
                  " while creating a new Treatment Plan Request.",
              });
            }
            this.loading = false;
          }
        }
      }
    },
    editClicked() {
      this.$router.push({
        path: "surgicalCaseForm",
        query: { id: this.surgicalCase.metadata.surgicalCaseId },
      });
    },
  },
};
</script>

<style scoped>
#caseDetails {
  text-align: left;
  margin: 0 30px;
  padding-bottom: 30px;
}

#idCoveringReps {
  list-style-type: none;
  padding-left: 0;
}

.details-nav {
  border-bottom: 1px solid #d3d3d3 !important;
}

a {
  color: #2c3e50;
}
.navActive {
  border-bottom: 4px solid #ffb500 !important;
  border-left: 0px !important;
  border-top: 0px !important;
  border-right: 0px !important;
  font-weight: bold;
}
ul {
  margin-bottom: 0;
}
#idCaseNav {
  margin: 1rem;
}
</style>